import { searchCatalog, nkrCodeOf, storesOf } from "./catalog.js";
import { getStoresStock } from "../api.js";

export default {
  definition: {
    name: "check_stock",
    description:
      "Consulta cuántas piezas hay de cada código y se lo muestra al vendedor en una tabla: en cada tienda (departamento) y bodega del país actual, y el total en cada país (USA, Costa Rica, Venezuela). Con codes vacío consulta las piezas que el vendedor eligió en las tarjetas. El total por país viene del último sync de cada país con Infoauto.",
    strict: true,
    input_schema: {
      type: "object",
      properties: {
        codes: {
          type: "array",
          items: { type: "string" },
          description:
            "Códigos de pieza (NKR, unificado, OE o supersesión); vacío para las piezas elegidas"
        }
      },
      required: ["codes"],
      additionalProperties: false
    }
  },

  async run({ codes }, ctx) {
    const requested = codes.length
      ? codes
      : ctx.getSelection().items.map(item => item.option.nkrCode);
    if (!requested.length) {
      throw new Error(
        "No hay códigos: el vendedor no eligió piezas ni se pasó ninguno."
      );
    }
    const rows = await Promise.all(
      requested.map(async code => {
        const hits = await searchCatalog(ctx, code, 3);
        // El código exacto si está; si no, lo más parecido
        const hit =
          hits.find(candidate =>
            (candidate.nkrCode || []).some(
              nkrCode => nkrCode.toUpperCase() === code.trim().toUpperCase()
            )
          ) || hits[0];
        if (!hit) return { code, found: false };
        return {
          code,
          found: true,
          nkrCode: nkrCodeOf(hit),
          title: hit.title,
          stores: storesOf(hit, ctx)
        };
      })
    );

    // Por país, con el código NKR encontrado aquí; uno que no está en este
    // país puede estar en otro, así que se busca tal cual
    const byCountry = await getStoresStock(
      rows.map(row => (row.found ? row.nkrCode : row.code.trim()))
    );
    rows.forEach((row, index) => {
      const country = byCountry[index];
      row.countries = (country ? country.stores : []).map(store => ({
        store: store.store,
        name: store.name,
        enabled: store.enabled,
        stock: store.stock
      }));
      // No está en este país pero sí en otro: el título de allá
      if (!row.found) {
        const elsewhere = (country ? country.stores : []).find(s => s.title);
        if (elsewhere) row.title = elsewhere.title;
      }
    });

    return {
      card: { type: "stock", rows },
      content: JSON.stringify({
        shownToUserAsCard: true,
        sellerStore: ctx.departmentCode,
        rows: rows.map(row => ({
          code: row.code,
          ...(row.found
            ? {
                nkrCode: row.nkrCode,
                title: row.title,
                storesInThisCountry: row.stores.map(store => ({
                  store: store.code,
                  total: store.total,
                  warehouses: store.warehouses
                }))
              }
            : { foundInThisCountry: false, title: row.title || null }),
          // enabled false: ese país no tiene la pieza en su tienda
          byCountry: row.countries.map(country => ({
            country: country.name,
            enabled: country.enabled,
            stock: country.stock
          }))
        }))
      })
    };
  }
};
